import { useBlockProps, MediaUpload, InspectorControls } from '@wordpress/block-editor';
import { PanelBody, TextControl, Button, TextareaControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

export default function Edit({ attributes, setAttributes }) {
    const { bgImage, titleText, descriptionText, buttonText, buttonUrl, testimonialText, authorName, authorImage } = attributes;

    const onImageSelect = (image, key) => setAttributes({ [key]: image.url });

    return (
        <>
            <InspectorControls>
                <PanelBody title={__('Settings', 'testimonial-block')}>
                    <TextControl
                        label={__('Title Text', 'testimonial-block')}
                        value={titleText}
                        onChange={(value) => setAttributes({ titleText: value })}
                    />
                    <TextareaControl
                        label={__('Description', 'testimonial-block')}
                        value={descriptionText}
                        onChange={(value) => setAttributes({ descriptionText: value })}
                    />
                    <TextControl
                        label={__('Button Text', 'testimonial-block')}
                        value={buttonText}
                        onChange={(value) => setAttributes({ buttonText: value })}
                    />
                    <TextControl
                        label={__('Button URL', 'testimonial-block')}
                        value={buttonUrl}
                        onChange={(value) => setAttributes({ buttonUrl: value })}
                    />
                    <TextareaControl
                        label={__('Testimonial Text', 'testimonial-block')}
                        value={testimonialText}
                        onChange={(value) => setAttributes({ testimonialText: value })}
                    />
                    <TextControl
                        label={__('Author Name', 'testimonial-block')}
                        value={authorName}
                        onChange={(value) => setAttributes({ authorName: value })}
                    />
                    <MediaUpload
                        onSelect={(image) => onImageSelect(image, 'authorImage')}
                        allowedTypes={['image']}
                        render={({ open }) => (
                            <Button onClick={open} variant="secondary">
                                {__('Select Author Image', 'testimonial-block')}
                            </Button>
                        )}
                    />
                    <MediaUpload
                        onSelect={(image) => onImageSelect(image, 'bgImage')}
                        allowedTypes={['image']}
                        render={({ open }) => (
                            <Button onClick={open} variant="secondary">
                                {__('Select Background Image', 'testimonial-block')}
                            </Button>
                        )}
                    />
                </PanelBody>
            </InspectorControls>

            <div {...useBlockProps()} style={{ backgroundImage: `url(${bgImage})` }}>
                <div className="testimonial-left">
                    <h3>{titleText}</h3>
                    <p>{descriptionText}</p>
                    <a href={buttonUrl} className="testimonial-btn">
                        {buttonText}
                    </a>
                </div>
                <div className="testimonial-right">
                    <div className="testimonial-content">
                        <p>{testimonialText}</p>
                        <div className="testimonial-author">
                            {authorImage && <img src={authorImage} alt={authorName} />}
                            <p>{authorName}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
const onImageSelect = (image, key) => {
    console.log('Selected image:', image.url);  // Debugging line
    setAttributes({ [key]: image.url });
};
